import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IncidentDetailsDialogData {
  message: string;
}

@Component({
  selector: 'app-incident-details-dialog',
  templateUrl: './incident-details-dialog.component.html',
  styleUrls: ['./incident-details-dialog.component.css'],
})
export class IncidentDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<IncidentDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IncidentDetailsDialogData,
  ) {}
}
